export const USER_LOGIN = 'user_login';
export const USER_LOGOUT = 'user_logout';
export const LOGIN_SUCCESS = 'login_success';
export const LOGIN_FAILED = 'login_failed';

export const PAGE_TYPE = 'page_type';
export const SAVE_SYSTEM_VERSION = 'save_system_version';
export const LOGIN_INFO = 'login_info';